import { ROOM_RATE_LPC_TYPE } from '~/consts/ratePlans';

import { RatePlan } from '~/hooks/apis/reservation/usePropertyRatePlans';

/** Promotions tied to LPC (Luxury Premium Collection) room rate plans only. */
export function selectLpcPromotionalDiscounts(
  ratePlans: Array<RatePlan>,
  promotionalDiscounts: Array<App.RatePlanPromotion>,
): Array<App.RatePlanPromotion> {
  const lpcRatePlanIds = new Set(ratePlans.filter((p) => p.product_type === ROOM_RATE_LPC_TYPE).map((p) => p.id));
  if (lpcRatePlanIds.size === 0) {
    return [];
  }
  return promotionalDiscounts.filter((d) => lpcRatePlanIds.has(d.rate_plan_id));
}
